import { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { sendMagicLink, setToken } from "../../lib/magic";
import { UserContext } from "../../lib/UserContext";
import { Typography } from "antd";
import EmailForm from "./components/EmailForm";
import Footer from "../footer/Footer";
import "./login.scss";
import ProgressContext from "../../lib/ProgressContext";
import {
  updateUserName,
  getCurrentUser,
  updateUserScore,
} from "../../store/user";
import Navigation from "../navigation/Navigation";
import Loading from "../loading/Loading";

const { Title } = Typography;

const Login = ({ isSignUp, checkCurrentLevel }) => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [user, setUser] = useContext(UserContext);
  const [isSignUpPage, setIsSignUpPage] = useState(true);
  const [progress, setProgress] = useContext(ProgressContext);
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [sentEmail, setSentEmail] = useState("");

  useEffect(() => {
    setIsSignUpPage(isSignUp);
  }, [isSignUp]);

  useEffect(() => {
    user && user.user && navigate("/");
  }, [user, navigate]);

  async function handleLoginWithEmail(username, email) {
    try {
      setDisabled(true);
      setIsLoading(true);
      await sendMagicLink(email);
      setSentEmail(email);
      setEmailSent(true);
      setIsLoading(false);
      setDisabled(false);
    } catch (error) {
      setDisabled(false);
      setIsLoading(false);
      console.error(error);
    }
  }

  if (emailSent) {
    return (
      <>
        <Navigation isLoginHeader={true} />
        <div className="login">
          <div className="login-box">
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ fontSize: "48px", marginBottom: "16px" }}>✉️</div>
              <Title level={2} className="login__name">
                Check your email
              </Title>
              <p style={{ color: "#a0a0b0", fontSize: "16px", lineHeight: "1.6", marginBottom: "24px" }}>
                We sent a login link to<br />
                <strong style={{ color: "#ffffff" }}>{sentEmail}</strong>
              </p>
              <p style={{ color: "#666680", fontSize: "14px" }}>
                Click the link in the email to log in.<br />
                The link expires in 15 minutes.
              </p>
              <p
                style={{ color: "#3C8618", cursor: "pointer", marginTop: "24px", fontSize: "14px" }}
                onClick={() => {
                  setEmailSent(false);
                  setSentEmail("");
                }}
              >
                ← Use a different email
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      {!isLoading ? (
        <>
          <Navigation isLoginHeader={true} />
          <div className="login">
            <div className="login-box">
              <Title level={1} className="login__name">
                {isSignUpPage ? "Sign up" : "Log in"}
              </Title>
              <p>
                Enter your email and we will send you a magic link to register
                or log in.
              </p>
              <EmailForm
                disabled={disabled}
                onEmailSubmit={handleLoginWithEmail}
                isSignUpPage={isSignUpPage}
              />

              <p className="login__action">
                {isSignUpPage
                  ? "Already have an account? "
                  : "Don't have an account? "}
                {isSignUpPage ? (
                  <Link className="login__link" to="/login">
                    Log in
                  </Link>
                ) : (
                  <Link className="login__link" to="/signup">
                    Sign up
                  </Link>
                )}
              </p>
            </div>
            <Footer />
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Login;
